export default __webpack_public_path__ + "static/media/committees-hero.cdaef8ca.png";